
const places = ({ apiClient }) => ({
  list(params) {
    return apiClient.get('/places', {}, params)
  },
})

export default places
